import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { WebsiteConstants } from '.././global/website-constants';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {

  private masterUrl = WebsiteConstants.MasterUrl;
  changepasswordUrl = this.masterUrl+"ChangePassword/ChangePassword";
  constructor(private http : HttpClient) { }

  changepassword(body,headers)
  {
      return this.http.post(this.changepasswordUrl,body,headers)
  }


}
